import { LoadingButton } from "@mui/lab";
import { Avatar, TextField, Button } from "@mui/material";
import React, { useContext, useState, useRef } from "react";
import { httpService } from "../httpService";
import { AlertContext } from "../contexts/AlertContext";
import logo from "./logo.png";
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";
import { Print } from "@mui/icons-material";

function PrintTags() {
  const [code, setCode] = useState("");
  const componentRef = useRef();
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(false);

  const { setAlertData } = useContext(AlertContext);
  const printData = async (e) => {
    e.preventDefault();

    setLoading(true);
    const { data, error } = await httpService.post("findparticipant", { code });

    if (data) {
      setParticipants(data);
    }
    if (error) {
      setAlertData({ open: true, message: error, severity: "error" });
    }
    setLoading(false);
  };
  return (
    <div>
      <div className="mt-5 container">
        <h3>Print participant's tag</h3>

        <div className="mt-4">
          <div className="col-lg-4">
            <form onSubmit={printData}>
              <TextField
                fullWidth
                label="Registration ID"
                className="mb-2"
                required
                onChange={(e) => setCode(e.target.value)}
              />
              <LoadingButton
                endIcon={<Print />}
                type="submit"
                variant="contained"
                loading={loading}
                color="error"
              >
                Print participant tag
              </LoadingButton>
            </form>
          </div>
        </div>

        <div className="mt-3">
          <div ref={componentRef}>
            {participants.map((participant) => (
              <div>
                <div
                  className="d-flex flex-wrap mt-3"
                  style={{ marginBottom: 40 }}
                >
                  <div style={{ width: 350 }} className="me-1 ms-2">
                    <div className="text-center">
                      <div className="mb-3 d-flex justify-content-center">
                        <img style={{ height: 80, width: 100 }} src={logo} />
                      </div>
                      <div className="mb-3">
                        <h6 style={{ textTransform: "uppercase" }}>
                          2024 POLICY MEETING & 4<sup>th</sup> Edition of
                          NATAP-M Awards
                        </h6>
                      </div>
                      <div className="mb-3 d-flex justify-content-center ">
                        <img
                          height={240}
                          width={240}
                          className="object-fit-fill "
                          //className="img-thumbnail"
                          src={participant.imageURL}
                          alt={participant.code}
                        />
                      </div>

                      <h3
                        style={{
                          fontWeight: "700",
                          textTransform: "uppercase",
                          margin: 0,
                        }}
                      >
                        {participant.title} {participant.firstName}{" "}
                        {participant.lastName}
                      </h3>

                      <h4
                        style={{
                          fontWeight: "700",
                          textTransform: "uppercase",
                          margin: 0,
                        }}
                      >
                        {participant.code}
                      </h4>
                    </div>
                  </div>
                  <div
                    className="d-flex align-items-center d-flex justify-content-center col-lg-12"
                    style={{ width: 350 }}
                  >
                    <div className="text-center">
                      <p>
                        Thursday 18<sup>th</sup> July, 2024 <br />
                        Auditorium & Banquet Hall
                        <br />
                        Body of Benchers Headquarters
                        <br />
                        Abuja, FCT
                      </p>

                      <QRCode size={180} value={participant._id} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="container">
            <div>
              <ReactToPrint
                trigger={() => {
                  return (
                    <Button
                      // disabled={
                      //   !participants.every((c) => c.status === "complete")
                      // }
                      variant="contained"
                    >
                      print tag
                    </Button>
                  );
                }}
                content={() => componentRef.current}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrintTags;

function SpecialTags() {
  const componentRef = useRef();
  return (
    <div>
      <div>
        <div ref={componentRef}>
          <div
            className="d-flex flex-wrap mt-3"
            style={{ marginBottom: 50, marginTop: 30 }}
          >
            <div style={{ width: 350 }} className="me-1 ms-2">
              <div className="text-center">
                <div className="mb-3 d-flex justify-content-center">
                  <img
                    style={{ height: 80, width: 100 }}
                    src={logo}
                    alt="logo"
                  />
                </div>
                <div className="mb-3">
                  <h6 style={{ textTransform: "uppercase" }}>
                    2024 POLICY MEETING & 4<sup>th</sup> Edition of NATAP-M
                    Awards
                  </h6>
                </div>

                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: 360 }}
                >
                  <p
                    style={{
                      fontWeight: "900",
                      textTransform: "uppercase",
                      margin: 0,
                      fontSize: 80,
                    }}
                  >
                    PRESS
                  </p>
                </div>
              </div>
            </div>
            <div
              className="d-flex align-items-center d-flex justify-content-center col-lg-12"
              style={{ width: 350 }}
            >
              <div className="text-center">
                <p>
                  Thursday 18<sup>th</sup> July, 2024 <br />
                  Auditorium & Banquet Hall
                  <br />
                  Body of Benchers Headquarters
                  <br />
                  Abuja, FCT
                </p>

                <QRCode size={180} value={"PRESS"} />
              </div>
            </div>
          </div>
          <div className="d-flex flex-wrap mt-3" style={{ marginBottom: 40 }}>
            <div style={{ width: 350 }} className="me-1 ms-2">
              <div className="text-center">
                <div className="mb-3 d-flex justify-content-center">
                  <img
                    style={{ height: 80, width: 100 }}
                    src={logo}
                    alt="logo"
                  />
                </div>
                <div className="mb-3">
                  <h6 style={{ textTransform: "uppercase" }}>
                    2024 POLICY MEETING & 4<sup>th</sup> Edition of NATAP-M
                    Awards
                  </h6>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: 360 }}
                >
                  <h1
                    style={{
                      fontWeight: "900",
                      textTransform: "uppercase",
                      margin: 0,
                      fontSize: 70,
                    }}
                  >
                    SPECIAL GUEST
                  </h1>
                </div>
              </div>
            </div>
            <div
              className="d-flex align-items-center d-flex justify-content-center col-lg-12"
              style={{ width: 350 }}
            >
              <div className="text-center">
                <p>
                  Thursday 18<sup>th</sup> July, 2024 <br />
                  Auditorium & Banquet Hall
                  <br />
                  Body of Benchers Headquarters
                  <br />
                  Abuja, FCT
                </p>

                <QRCode size={180} value={"SPECIAL GUEST"} />
              </div>
            </div>
          </div>
          <div className="d-flex flex-wrap mt-3" style={{ marginBottom: 40 }}>
            <div style={{ width: 350 }} className="me-1 ms-2">
              <div className="text-center">
                <div className="mb-3 d-flex justify-content-center">
                  <img
                    style={{ height: 80, width: 100 }}
                    src={logo}
                    alt="logo"
                  />
                </div>
                <div className="mb-3">
                  <h6 style={{ textTransform: "uppercase" }}>
                    2024 POLICY MEETING & 4<sup>th</sup> Edition of NATAP-M
                    Awards
                  </h6>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{ height: 360 }}
                >
                  <h1
                    style={{
                      fontWeight: "900",
                      textTransform: "uppercase",
                      margin: 0,
                      fontSize: 80,
                    }}
                  >
                    GUEST
                  </h1>
                </div>
              </div>
            </div>
            <div
              className="d-flex align-items-center d-flex justify-content-center col-lg-12"
              style={{ width: 350 }}
            >
              <div className="text-center">
                <p>
                  Thursday 18<sup>th</sup> July, 2024 <br />
                  Auditorium & Banquet Hall
                  <br />
                  Body of Benchers Headquarters
                  <br />
                  Abuja, FCT
                </p>

                <QRCode size={180} value={"GUEST"} />
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <ReactToPrint
            trigger={() => {
              return <Button variant="contained">print tag</Button>;
            }}
            content={() => componentRef.current}
          />
        </div>
      </div>
    </div>
  );
}

export { SpecialTags };
